import ToolTip from '../../../Shared/ToolTip'
import Button from '../../../Shared/Form/Button'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import './style.scss'
import activityTrackingService from '../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../constants'
import { ReactComponent as FileUploadIcon } from '../../../../assets/img/icons/file-upload.svg'
import { BUTTON_MIN_WIDTH } from '../../../Shared/Form/Button/constants'
import usePublishGuard from './usePublishGuard'

const PublishAllButton = memo(({ giataId, publishAllowed = true }) => {
  const {
    hasUnpublishedChanges,
    publishInProgress,
    // this is used to show the lighter button with the unconfirmed images tooltip
    isBlockedUnconfirmedImages: isPublishBlockedUnconfirmedImages,
    isBlockedNoPropertyImages: isPublishBlockedNoPropertyImages,
    isBlockedByImages,
    publish,
  } = usePublishGuard({ giataId, publishAllowed })

  const { t } = useTranslation()
  const commonClasses = 'Button-PublishAll ToolTip-Handle'
  const publishPossible = publishAllowed && !isBlockedByImages
  const buttonDisabled = !hasUnpublishedChanges
    // button is not disabled if we have an unconfirmed image state in redux even if publish is not allowed by the prop
    || (!publishAllowed && !isBlockedByImages)
    || publishInProgress
  const onClick = () => {
    if (isBlockedByImages) {
      activityTrackingService.trackEvent(trackingEvent.clickBlockedPublishedButton)
      return
    }
    publish({ source: 'publishAllButton' })
  }
  return (
    <Button
      disabled={buttonDisabled}
      onClick={onClick}
      classNames={commonClasses}
      variant={isBlockedByImages ? 'quaternary' : 'primary'}
      icon={<FileUploadIcon/>}
      minWidth={BUTTON_MIN_WIDTH}
    >
      {t('PUBLISH_ALL')}
      {
        !buttonDisabled && publishPossible && <ToolTip className="ToolTip-Bottom">{t('PUBLISH_ALL_TOOLTIP')}</ToolTip>
      }
      {
        !publishPossible
        && isPublishBlockedUnconfirmedImages
        && <ToolTip className="ToolTip-Bottom">{t('CONFIRM_IMAGES_BEFORE_PUBLISH')}</ToolTip>
      }
      {
        !publishPossible
        && isPublishBlockedNoPropertyImages
        && <ToolTip className="ToolTip-Bottom">{t('property.publishButton.disabledTooltip.noPropertyImages')}</ToolTip>
      }
    </Button>
  )
})

export default PublishAllButton
